module.exports = "/davinci/assets/ab93ca5dc25e8d2a901b106d7091da2b.jpg";